import React from 'react';

const About = () => {
  return (
    <section id="about" className="section bg-light">
      <div className="container">
        <h2 className="section-title">Who We Are</h2>
        <div className="about-intro">
          <p>CompileX is a software development company focused on advanced engineering and emerging technologies. Our team combines practical development experience with research-oriented thinking to build systems that are robust, efficient, and future-ready.</p>
          <p>We believe great software is built where clarity, curiosity, and discipline meet.</p>
        </div>

        <div className="about-grid">
          <div className="about-card">
            <div className="about-icon-wrapper" aria-hidden="true">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" opacity="0.12" />
                <circle cx="12" cy="12" r="6" stroke="currentColor" strokeWidth="1.5" />
                <circle cx="12" cy="12" r="2" fill="currentColor" />
              </svg>
            </div>
            <h3>Our Mission</h3>
            <p>Engineer reliable, intelligent software that solves real-world problems and pushes technological boundaries.</p>
          </div>

          <div className="about-card">
            <div className="about-icon-wrapper">
              <i className="fas fa-eye"></i>
            </div>
            <h3>Our Vision</h3>
            <p>Become a trusted technology partner for companies building next-generation digital products.</p>
          </div>

          <div className="about-card">
            <div className="about-icon-wrapper">
              <i className="fas fa-brain"></i>
            </div>
            <h3>How We Think</h3>
            <ul className="check-list">
              <li><i className="fas fa-check-circle"></i> Problems before tools</li>
              <li><i className="fas fa-check-circle"></i> Research before assumptions</li>
              <li><i className="fas fa-check-circle"></i> Quality before speed</li>
              <li><i className="fas fa-check-circle"></i> Long-term value</li>
            </ul>
          </div>

          <div className="about-card">
            <div className="about-icon-wrapper">
              <i className="fas fa-chart-line"></i>
            </div>
            <h3>Our Impact</h3>
            <div className="stats">
              <div className="stat">
                <span className="stat-number">50+</span>
                <span className="stat-label">Projects</span>
              </div>
              <div className="stat">
                <span className="stat-number">5+</span>
                <span className="stat-label">Years</span>
              </div>
              <div className="stat">
                <span className="stat-number">100%</span>
                <span className="stat-label">Satisfaction</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
